export default "__VITE_ASSET__1uu$DRGg__"